module.exports = __webpack_public_path__ + "static/img/3_4_1.5759c042.png";